
<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <!--<div class="col-md-1 padding-left-0px padding-right-0px">
          <a class="education-navlink addicon-circle">
            <span class="badge">

              <i class="fas fa-user-plus"></i>
            </span>
          </a>
        </div>-->
        <div class="col-md-4 padding-left-9px padding-right-0px">
          <label class="margin-top-3px">Profile</label>
        </div>
        <div class="col-md-6 padding-left-0px">
          <label class="margin-top-3px">Active Plan</label>
          
        </div>
        <div class="col-md-2">
          <button type="button" class="close float-right margin-top-4px" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        
      </div>



    </div>
  
      <div class="modal-body padding-top-0px counselling-modal">

        <div class="row" >
          <div class="position-fixed-counselling">
            <div class=" card bk-color-light2 card-height">
              <div class="row margin-top-10" *ngIf="SelectedPatient">
                <div class="offset-md-3 col-md-3 padding-left-0px">
                  <img class="img-circle-50 margin-left-10px" [src]="SelectedPatient.PatientImageFile" onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row" *ngIf="SelectedPatient">
                <div class="offset-md-1 col-md-9 padding-left-0px padding-right-0px text-align-center">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{SelectedPatient.DisplayName}}</label>
                </div>
              </div>
              <div class="row" *ngIf="SelectedPatient">
                <div class="offset-md-3 col-md-7">
                  <label class="margin-bottom-0px">{{SelectedPatient.FormattedCode}}</label>
                </div>
              </div>
              <div class="row" *ngIf="SelectedPatient">
                <div class="offset-md-3 col-md-12">
                  <label class="margin-bottom-0px">
                    <!--32yrs,Female-->
                    {{SelectedPatient.Age}},{{SelectedPatient.Gender}}
                  </label>
                </div>
              </div>
              <div class="row" *ngIf="SelectedPatient">
                <!--<div class="col-md-3">
          <label>Phone Number:</label>
        </div>-->
                <div class="offset-md-3 col-md-6">
                  {{SelectedPatient.Telephone1}}
                </div>
              </div>
            </div>
            </div>
            <div class="offset-md-4 col-md-8">
              
               
               
                  <div class="card">
                    <div class="card-body padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px padding-top-0px">
                      
                      <div class="row">
                        <div class="col-md-12">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="row margin-top-10 ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px"><span>*</span>Branch</label>
                                  </div>:


                                  <div class="col-md-5">
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                             id="CurrentEditCounsellingPlanRequest.BranchCode" SelectedValue="CurrentEditCounsellingPlanRequest.BranchCode"
                                                             [(ngModel)]="CurrentEditCounsellingPlanRequest.BranchCode" (keyChange)="onAssignedToActorCode($event)"
                                                             name="CurrentEditCounsellingPlanRequest.BranchCode" required>
                                    </CustomDataByRequestType>-->
                                    <label class="margin-bottom-0px font-size-12px margin-top-3px">{{FacilityShortName}}</label>

                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px"><span>*</span>Choose Treatment Plan</label>
                                  </div>:


                                  <div class="col-md-5">
                                    <!--<CodeTypeValue CodeType="CNSPN"
                                                   id="CurrentEditCounsellingPlanRequest.TreatmentPlan"
                                                   [(ngModel)]="CurrentEditCounsellingPlanRequest.TreatmentPlan" SelectedValue="CurrentEditCounsellingPalnRequest.TreatmentPlan"
                                                   name="CurrentEditCounsellingPlanRequest.TreatmentPlan" required>

                                    </CodeTypeValue>-->
                                    <label class="margin-bottom-0px font-size-12px margin-top-3px">{{CurrentEditCounsellingPlanRequest.TreatmentPlan}}</label>

                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                                  </div>


                                  <div class="col-md-5">
                                    <div class="date-form">
                                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                      <a (click)="d.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>

                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row  ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                                  </div>


                                  <div class="col-md-5">
                                    <input type="text" class="form-control" placeholder="Recommended Package"
                                           id="CurrentEditCounsellingPlanRequest.RecommendedPackage"
                                           [(ngModel)]="CurrentEditCounsellingPlanRequest.RecommendedPackage" required
                                           name="CurrentEditCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                           maxlength="100" />
                                    <small class="form-text text-danger"
                                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row  ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Counselling Doctor</label>
                                  </div>


                                  <div class="col-md-5">
                                    <input type="text" class="form-control" placeholder="Counselling Doctor"
                                           id="CurrentEditCounsellingPlanRequest.CounsellingDoctor"
                                           [(ngModel)]="CurrentEditCounsellingPlanRequest.CounsellingDoctor"
                                           name="CurrentEditCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>
                                    <!--<input type="text" class="form-control" placeholder="Counselling Doctor"
          id="Doctor"
          [(ngModel)]="Doctor"
          name="Doctor" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Doctor="ngModel" maxlength="20" min="4"/>-->


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Package Cost</label>
                                  </div>

                                  <div class="col-md-5">
                                    <input type="number" class="form-control" placeholder="Package Cost"
                                           id="CurrentEditCounsellingPlanRequest.PackageCost"
                                           [(ngModel)]="CurrentEditCounsellingPlanRequest.PackageCost"
                                           name="CurrentEditCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>

                                  </div>
                                  <!--<div class="col-md-3 text-align-right margin-top-7px">
          <label for="diaplayname" class="font-size-12px margin-bottom-0px">emi option</label>
        </div>-->
                                  <!--<div class="col-md-2">
          <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


        </div>-->
                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-top-7px">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                                  </div>

                                  <div class="col-md-5">
                                    <input type="checkbox" class="form-control width-14px" id="CurrentEditCounsellingPlanRequest.SelectEmi"
                                           [(ngModel)]="CurrentEditCounsellingPlanRequest.SelectEmi" name="CurrentEditCounsellingPlanRequest.SelectEmi">


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                                  </div>

                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="FNSTS"
                                                   id="CurrentEditCounsellingPlanRequest.FinancialStatus"
                                                   [(ngModel)]="CurrentEditCounsellingPlanRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                   name="CurrentEditCounsellingPlanRequest.FinancialStatus">
                                    </CodeTypeValue>
                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                                  </div>

                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="PTNT"
                                                   id="CurrentEditCounsellingPlanRequest.Potential"
                                                   [(ngModel)]="CurrentEditCounsellingPlanRequest.Potential" SelectedValue="CurrentEditCounsellingPalnRequest.Potential"
                                                   name="CurrentEditCounsellingPlanRequest.Potential">
                                    </CodeTypeValue>
                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row margin-top-10 ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                                  </div>


                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="PNSTS"
                                                   id="CurrentEditCounsellingPlanRequest.PlanStatus"
                                                   [(ngModel)]="CurrentEditCounsellingPlanRequest.PlanStatus" SelectedValue="CurrentEditCounsellingPalnRequest.PlanStatus"
                                                   name="CurrentEditCounsellingPlanRequest.PlanStatus">

                                    </CodeTypeValue>


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End </label>
                                  </div>


                                  <div class="col-md-5">

                                    <div class="date-form">
                                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                      <a (click)="d1.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>

                                    </div>

                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                                  </div>

                                  <div class="col-md-6 padding-right-0px">
                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                              name="CurrentEditCounsellingPlanRequest.Concerns"
                                              [(ngModel)]="CurrentEditCounsellingPlanRequest.Concerns" required minlength="1" maxlength="100"
                                              #addconcerns_text="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row margin-top-14p float-right">
                              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" (click)="activeModal.close('Close click')">Cancel</button>
                              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting && isvisible' class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                            </div>


                          </form>
                        </div>
                      </div>
                    </div>
                  </div>


                  <!--<div class="row" *ngFor="let p of CurrentCounsellingPlanController">
            <label>{{p.TreatmentPlan}} - {{p.StartDate}}</label>
          </div>-->





              
            
            </div>
          </div>



        </div>
      <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
        <button type="submit" class="btn font-size-13px actions-btn-prime">Save</button>
      </div>-->
   
  </div>
</div>
